import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function Audit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs?limit=300").then(r => setLogs(r.data)); }, []);
  return (
    <div className="space-y-6">
      <header>
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500">Audit Log</p>
        <h1 className="font-heading text-4xl font-black tracking-tighter mt-1">Every action, traced.</h1>
      </header>
      <Card className="bg-[#141414] border-zinc-800 p-6">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-zinc-500 text-xs font-mono uppercase">
                <th className="py-2 pr-4">When</th><th className="py-2 pr-4">Actor</th>
                <th className="py-2 pr-4">Action</th><th className="py-2 pr-4">Entity</th>
                <th className="py-2 pr-4">Details</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800">
              {logs.map(l => (
                <tr key={l.id}>
                  <td className="py-2 pr-4 text-zinc-400 text-xs">{new Date(l.created_at).toLocaleString()}</td>
                  <td className="py-2 pr-4 text-xs">{l.actor_email || "—"}</td>
                  <td className="py-2 pr-4 font-mono text-xs">{l.action}</td>
                  <td className="py-2 pr-4 text-xs">{l.entity_type || "—"}</td>
                  <td className="py-2 pr-4 text-xs text-zinc-500 font-mono max-w-md truncate">{JSON.stringify(l.details || {})}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
